AFRAME.registerComponent("cookie-consent", {
    schema: {
        isShow: { type: 'boolean', default: false }
    },
    
    init: function() {
        this.declineButton = this.el.querySelector('.decline-button');
        this.acceptButton = this.el.querySelector('.accept-button');
        this.coockieButton = document.querySelector('#chart-type-control .cookie-button');
        this.coockieButtonImage = document.querySelector('#chart-type-control .cookie-button-image');
        this.cookiePolicyLink = this.el.querySelector('.cookie-policy-link');

        this.setListeners();
    },


    
    setListeners: function() {
        
        if (this.declineButton) this.declineButton.addEventListener('click', this.handleDeclineConsent.bind(this));
        if (this.acceptButton) this.acceptButton.addEventListener('click', this.handleAcceptConsent.bind(this));
        
        this.el.addEventListener('cookie-consent-updated', (e) => {
            console.log('cookie-consent-updated event received', e);
            if (e.detail && e.detail.consentGiven) {
                this.closeConsent();
            } else {
                this.showConsent();
            }
        })
        
        if (this.coockieButton) this.coockieButton.addEventListener('click', this.switchCookiePopUpVisibility.bind(this));
        if (this.cookiePolicyLink) this.cookiePolicyLink.addEventListener('click', this.handleCookiePolicyClick.bind(this));
    },

    handleAcceptConsent: function () {        
        if (window.cookieConsentInstance) {
             window.cookieConsentInstance.setStatus('allow');
        }
        
        this.closeConsent();
    },
    handleDeclineConsent: function () {        
        if (window.cookieConsentInstance) {
            window.cookieConsentInstance.setStatus('deny');
        }
        
        this.closeConsent();
    },

    handleCookiePolicyClick: function () {
        const sceneEl = document.querySelector('a-scene');
        if (sceneEl) {
            sceneEl.exitVR();
        }
        window.location.href = 'privacy.html';
    },
    
    switchCookiePopUpVisibility: function () {
        const isVisible = this.el.getAttribute('visible');
        if (isVisible) {
            this.closeConsent();
        } else {
            this.showConsent();
        }
    },
    
    closeConsent: function () {
        this.el.setAttribute('visible', false);
        this.el.setAttribute('position', '0 12.5 -0.25');
        if (this.coockieButtonImage) this.coockieButtonImage.setAttribute('src', '#cookies-open-icon');
        document.dispatchEvent(new CustomEvent('vr-cookie-consent-closed'));
    },

    showConsent: function () {
        this.el.setAttribute('visible', true);
        this.el.setAttribute('position', '0 2.5 -0.25');
        if (this.coockieButtonImage) this.coockieButtonImage.setAttribute('src', '#cookies-close-icon');
    },

    update: async function (oldData) {
        if (oldData.isShow !== this.data.isShow) {
            if (this.data.isShow) {
                this.showConsent();
            } else {
                this.closeConsent();
            }
        }
    }
})